import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { UserCustom } from '../../types';
import { getErrorText } from '../helpers';

type Params = { roomId: string; filter?: string; next?: string };
type Response = Pubnub.GetAllUUIDMetadataResponse<UserCustom> & { withReset: boolean };
type RequestParams = {
  filter: string;
  include: {
    totalCount: boolean;
  };
  limit: number;
  sort: { updated: string };
  page: {
    next?: string;
  };
};

export const getAllUsersMetadata = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/getAllUsersMetadata',
  async (data, { rejectWithValue, getState }) => {
    try {
      const { roomId } = data;
      const pubnubReducer = (getState() as RootState).pubnub;
      const filter = data.filter || `id LIKE '${roomId}.*' && email != '0'`;
      const requestParams: RequestParams = {
        filter,
        include: {
          totalCount: true,
        },
        limit: 25,
        sort: { updated: 'desc' },
        page: {},
      };

      if (data.next && requestParams.page) {
        requestParams.page.next = data.next;
      }

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.objects.getAllUUIDMetadata<UserCustom>(requestParams);

        return { ...result, withReset: !Boolean(data.next) };
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
